import React, { memo } from 'react';
import { Button } from '@cognitiv/cyprus-ui';
import classNames from 'classnames';
import { BottomNavigationProps } from 'ducks/types/prop-types';
import { useSwitchTheme } from 'hooks/useSwitchTheme';

import cn from 'components/bottom-navigation/BottomNavigation.module.scss';

const BottomNavigationBase = ({
  current = 0,
  end,
  save = false,
  disabled = false,
  onClose,
  onBack,
  read_only = false,
  onNext,
}: BottomNavigationProps) => {
  const { is_dark_theme } = useSwitchTheme();
  return (
    <div className={cn.buttons}>
      <div className={cn.flexGrow} />
      <p className={classNames(cn.cancel, { [cn.dark]: is_dark_theme })} role="presentation" onClick={onClose}>
        Cancel
      </p>
      {current !== 0 && (
        <Button
          outline
          variant="blue"
          theme={{ button_font_color: '#276ef1' }}
          onClick={onBack}
          margin="0px 0px 0px 15px"
          width={164}
        >
          Previous
        </Button>
      )}
      {end && current !== end && (
        <>
          <Button
            outline
            variant="blue"
            theme={{ button_font_color: '#276ef1' }}
            onClick={onNext}
            margin="0px 0px 0px 15px"
            width={164}
          >
            Next: Parameters
          </Button>
          {!read_only && (
            <Button type="submit" margin="0px 0px 0px 15px" disabled={disabled} variant="blue" width={164}>
              {save ? 'Save' : 'Run'}
            </Button>
          )}
        </>
      )}
      {end && current === end && (
        <Button type="submit" margin="0px 0px 0px 15px" disabled={disabled} variant="blue" width={164}>
          {save ? 'Save' : 'Run'}
        </Button>
      )}
    </div>
  );
};

export const BottomNavigation = memo(BottomNavigationBase);
